import { updateOrAddColumnOptionState, updateOrAddColumnTemplate, updateOrAddDatapointRequest } from "../../helpers";
import { ColumnTypesToChartSelectValueFormatKind } from "components/widgets/grid/grid-column-types";
const gridOptionsToValuePairOptions = (col) => ({ displayValueType: ColumnTypesToChartSelectValueFormatKind[col.type || ""],
    id: col.id,
    title: col.name || "" });
export const updateMeasureForValuePair = (state, componentProps) => {
    const leftColumn = { fields: [] }, rightColumn = { fields: [] };
    state.editor.settings?.data?.columns?.options?.sort((a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0)).forEach((e, i) => {
        const newField = gridOptionsToValuePairOptions(e);
        if (newField.displayValueType === undefined) {
            newField.displayValueType = componentProps
                ?.pipelineParameter
                ?.customVisitorsReducer?.[0]
                ?.arguments?.[0]?.fields.find((field) => field?.id === newField?.id)?.displayValueType ||
                componentProps
                    ?.pipelineParameter
                    ?.customVisitorsReducer?.[0]
                    ?.arguments?.[1]?.fields.find((field) => field?.id === newField?.id)?.displayValueType;
        }
        if (i % 2 === 0) {
            leftColumn.fields.push(newField);
        }
        else {
            rightColumn.fields.push(newField);
        }
    });
    componentProps.pipelineParameter.customVisitorsReducer = [
        {
            arguments: [
                {
                    ...leftColumn
                },
                {
                    ...rightColumn
                }
            ],
            method: "valuePair"
        }
    ];
};
export const addOrUpdateMeasureForValuePair = (state, action, componentProps) => {
    const newColumnOption = updateOrAddColumnOptionState(state, action.payload);
    if (newColumnOption) {
        updateOrAddColumnTemplate(state, newColumnOption);
    }
    updateOrAddDatapointRequest(state, action.payload);
    updateMeasureForValuePair(state, componentProps);
};
